import { Tag } from "antd";
import { ReactElement } from "react";
import { MATCH_DATA_APPLICATION_RENDER } from "../../../enums/matchDataApplicationRender";
import { MatchCompRequestProps } from "../../../interfaces/props/MatchCompRequestProps";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_REQUEST_MATCH } from "../../../store/selectors/requestAppSelector";
import { UI_ModuleCard } from "../../../UI_ITO/indexUI";
import { Chat } from "../../Chat/Chat";
import { BankAgent } from "../BankAgent/BankAgent";
import { BankClient } from "../BankClient/BankClient";
import { BankCredit } from "../BankCredit/BankCredit";
import { DocList } from "../DocList/DocList";
import { PurchaseInfoList } from "../PurchaseInfoList/PurchaseInfoList";

import classes from "./MatchCompRequest.module.css";

// переключение компонентов на странице заявки
export function MatchCompRequest(props: MatchCompRequestProps): ReactElement {
  let { title, formChange } = props;

  const MATCH_RENDERS = useAppSelector(SELECT_REQUEST_MATCH);
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );
  const JsxMatchRender = {
    INFO_PURCHASE: <PurchaseInfoList formChange={formChange} />,
    DOCUMENT: <DocList />,
    DOCUMENT_ADMIN: <>DOCUMENT_ADMIN</>,
    CHAT: <Chat />,
    BANK_CREDIT: <BankCredit />,
    BANK_AGENT: <BankAgent />,
    BANK_CLIENT: <BankClient />,
    NOT_DATA: <>NOT_DATA</>,
  };

  function titleUiModule() {
    if (
      MATCH_RENDERS === MATCH_DATA_APPLICATION_RENDER.BANK_CREDIT ||
      MATCH_RENDERS === MATCH_DATA_APPLICATION_RENDER.BANK_AGENT ||
      MATCH_RENDERS === MATCH_DATA_APPLICATION_RENDER.BANK_CLIENT
    ) {
      return (
        <div className={classes.headerCard}>
          <p className={classes.bankTitle}>
            <span>{activeBankInfo.bank.title}</span>
          </p>

          <p className={classes.headerBankStatus}>
            <Tag color={activeBankInfo.status.color}>
              {activeBankInfo.status.title}
            </Tag>
          </p>
        </div>
      );
    }

    return title ? title : "";
  }

  return (
    <UI_ModuleCard title={titleUiModule()}>
      {JsxMatchRender[MATCH_RENDERS]}
    </UI_ModuleCard>
  );
}
